import { clearTransactionCache, fetchTransactions } from "../components/utils/fetchTxn";

export const refreshUserTransactions = async (userId) => {
    clearTransactionCache(userId);

    return await fetchTransactions(
        userId,
        null,
        { forceRefresh: true }
    );
};